<template>
  <div
    class="coupon-wrap flex"
    :class="{
      'is-use-wrap': type === 1,
      'is-due-wrap': type === 3
    }"
  >
    <div class="left">
      <div class="top">
        <div class="tilte-wrap flex">
          <div class="line"></div>
          <div class="title">优惠券</div>
        </div>
        <div class="time">
          有效期 {{ dayjs(couponItem.validFrom).format('YYYY.MM.DD') }} ~
          {{ dayjs(couponItem.validEnd).format('YYYY.MM.DD') }}
        </div>
      </div>
      <div class="bottom">
        <div class="coupon-name">
          <span>{{ couponItem.valueAmount }}元</span> {{ couponItem.name }}
        </div>
        <div class="coupon-desc" v-if="couponItem.minLimitAmount">
          {{
            couponItem.minLimitAmount
              ? `满${couponItem.minLimitAmount}可用`
              : '无门槛优惠券'
          }}
        </div>
      </div>
      <div class="use-course-wrap" v-if="type === 1 && couponItem.usage">
        <div class="use-course" @click="gotoUse(couponItem.usage.route)">
          该券已解锁：<span>{{ couponItem.usage.remark }}</span>
        </div>
        <div class="arrow"></div>
      </div>
    </div>
    <div class="right" @click="btnClick(couponItem)" v-if="type < 1">
      <div>立即使用</div>
    </div>
    <div class="status" v-else>{{ type === 1 ? '已使用' : '已过期' }}</div>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import { openurl } from '@em/ym'
import { Toast } from 'vant'
dayjs.extend(isBetween)
export default {
  name: 'CouponItem',
  props: {
    couponItem: {
      type: Object,
      required: true
    },
    type: {
      type: Number,
      default: 0 //0.未使用 1.已使用和已锁定 2.已锁定 3.已过期
    }
  },
  data() {
    return {}
  },
  setup() {
    function btnClick(item) {
      if (item.status === 4) {
        // 已冻结(退款后被冻结)
        Toast('您正在退款流程中，优惠券暂无法使用')
        return
      }
      if (!item.btnActive) return
      if (item.appLinkUrl) openurl(item.appLinkUrl)
    }

    function gotoUse(path) {
      console.info('path', path)
      openurl(path)
    }

    return {
      btnClick,
      dayjs,
      gotoUse
    }
  }
}
</script>
<style lang="scss" scoped>
.coupon-wrap {
  width: 686px;
  height: 214px;
  background: url(./images/red.png) no-repeat;
  background-size: cover;
  margin: 0 auto 30px;
  line-height: 1;
  &.is-use-wrap {
    height: 292px;
    position: relative;
    background-image: url('./images/use.png');
    .left {
      .bottom {
        .coupon-name {
          color: rgba(180, 180, 180, 1);
          //span {
          //  color: rgba(128, 128, 128, 1);
          //}
        }
      }
    }
  }
  &.is-due-wrap {
    height: 220px;
    position: relative;
    background-image: url('./images/gray.png');
    .status {
      top: 38%;
    }
    .left {
      .bottom {
        .coupon-name {
          color: rgba(180, 180, 180, 1);
          span {
            color: rgba(128, 128, 128, 1);
          }
        }
      }
    }
  }
  .left {
    flex: 1;
    display: flex;
    flex-direction: column;
    height: 100%;
    .use-course-wrap {
      height: 80px;
      font-size: 28px;
      color: #ffffff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      .use-course {
        //单行省略
        flex: 1;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        margin-right: 20px;
        width: 420px;
      }
      .arrow {
        flex: none;
        width: 24px;
        height: 24px;
        background: url(./images/arrow.png) no-repeat;
        background-size: 100% 100%;
      }
    }

    .bottom {
      flex: 1;
      padding: 0 20px;
      .coupon-name {
        font-size: 40px;
        color: rgba(0, 0, 0, 1);
        padding-top: 30px;
        span {
          color: rgba(250, 95, 85, 1);
        }
      }
      .coupon-desc {
        font-size: 28px;
        color: rgba(128, 128, 128, 1);
        margin-top: 16px;
      }
    }
    .top {
      padding: 0 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 60px;
      flex: none;
      .line {
        display: block;
        content: '';
        width: 4px;
        height: 22px;
        background: rgba(250, 95, 85, 1);
        margin-right: 6px;
      }
      .title {
        font-size: 28px;
        color: rgba(50, 50, 50, 1);
      }
      .time {
        font-size: 24px;
        color: rgba(128, 128, 128, 1);
      }
    }
  }
  .right {
    width: 60px;
    flex: none;
    color: rgba(255, 255, 255, 1);
    font-size: 28px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
    div {
      width: 30px;
    }
  }
  .status {
    position: absolute;
    top: 34%;
    right: 30px;
    width: 100px;
    height: 100px;
    opacity: 1;
    border-radius: 176px;
    background: rgba(180, 180, 180, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    font-size: 28px;
  }
}
</style>
